/* eslint-disable consistent-return */
import { formatMinutes } from './utils';

const examNameTranslation = (modality, semester, duration) => {
  const text = formatMinutes(duration);

  // Oral
  if (modality === 'Oral - Présentation d’article ou vidéo') {
    return {
      name: `Oral - Présentation d’article ou vidéo (${text})`,
      summary: 'Présentation d\'un article ou d\'une vidéo',
      grades: [
        'Structure de la présentation : 5/20',
        'Vocabulaire médical : 5/20',
        'Syntaxe et grammaire : 5/20',
        'Contenu, qualité de la présentation : 5/20',
      ],
    };
  }
  if (modality === 'Oral - Participation') {
    return {
      name: `Participation orale (${text})`,
      summary: 'Participation en cours d\'année',
      grades: [
        'Prise de parole sollicitée : 5/20',
        'Prise de parole spontanée : 5/20',
        'Présence et implication : 10/20',
      ],
    };
  }
  if (modality === 'Oral - Cours en présentiel') {
    return {
      name: `Oral - présentation (${text})`,
      summary: 'Présentation orale',
      grades: [
        'Structure de la présentation : 5/20',
        'Vocabulaire médical : 5/20',
        'Syntaxe et grammaire : 5/20',
        'Contenu, qualité de la présentation : 5/20',
      ],
    };
  }
  if (modality === 'Oral - Jeu de rôle') {
    return {
      name: `Oral - jeu de rôle (${text})`,
      summary: 'Présentation orale - role play',
      grades: [
        'Compréhension du contexte : 5/20',
        'Maîtrise de la langue : 5/20',
        'Vocabulaire : 10/20',
      ],
    };
  }
  if (modality === 'Oral - Étude de cas') {
    return {
      name: `Oral - Etude de cas (${text})`,
      summary: 'Présentation orale - étude de cas',
      grades: [
        'Compréhension du contexte : 5/20',
        'Syntaxe et grammaire : 5/20',
        'Vocabulaire médical : 5/20',
        'Qualité de la présentation : 5/20',
      ],
    };
  }
  if (modality === 'Oral - Présentation de poster') {
    return {
      name: `Oral - présentation de poster (${text})`,
      summary: 'Présentation orale - poster',
      grades: [
        'Qualité du poster (clarté du contenu, agencement) : 2.5/20',
        'Qualité de la présentation (pertinence, structure) : 2.5/20',
        'Grammaire et syntaxe : 5/20',
        'Vocabulaire médical : 10/20',
      ],
    };
  }

  // Tests de connaissances
  if (modality === 'Sur la plateforme - Test de connaissance 60 minutes') {
    return {
      name: `Quiz en ligne (${text})`,
      summary: 'Epreuve de connaissance du vocabulaire professionnel',
      grades: [
        'Compréhension de texte : 20/100',
        'Vocabulaire et termes médicaux : 80/100',
      ],
    };
  }
  if (modality === 'Sur la plateforme - Test de connaissance 90 minutes') {
    return {
      name: `Quiz en ligne (${text})`,
      summary: 'Epreuve de connaissance du vocabulaire professionnel',
      grades: [
        'Compréhension de texte : 20/100',
        'Vocabulaire et termes médicaux : 80/100',
      ],
    };
  }
  if (modality === 'Sur table - Test de connaissance 90 minutes') {
    return {
      name: `Examen sur table (${text})`,
      summary: 'Epreuve de connaissance du vocabulaire professionnel',
      grades: [
        'Compréhension de texte : 20/100',
        'Vocabulaire et termes médicaux : 80/100',
      ],
    };
  }
  if (modality === 'Sur table - Test de connaissance 60 minutes') {
    return {
      name: `Examen sur table (${text})`,
      summary: 'Epreuve de connaissance du vocabulaire professionnel',
      grades: [
        'Compréhension de texte : 20/80',
        'Vocabulaire et termes médicaux : 60/80',
      ],
    };
  }

  // Sur la plateforme
  if (modality === 'Sur la plateforme - Traduction') {
    return {
      name: `Examen sur la plateforme (${text})`,
      summary: 'Traduction d\'un article médical (anglais vers français)',
      grades: [
        'Vocabulaire et termes médicaux : 10/20',
        'Compréhension globale : 5/20',
        'Syntaxe : 5/20',
      ],
    };
  }
  if (modality === 'Sur la plateforme - Rédaction d\'un résumé') {
    return {
      name: `Examen sur la plateforme (${text})`,
      summary: 'Résumé d\'un texte en anglais',
      grades: [
        'Vocabulaire et termes médicaux : 10/20',
        'Structure : 3/20',
        'Contenu, qualité et idées globales : 5/20',
        'Syntaxe : 2/20',
      ],
    };
  }
  if (modality === 'Sur la plateforme - Dépôt de capsule vidéo') {
    return {
      name: `Examen sur la plateforme (${text})`,
      summary: 'Traduction d\'un article médical (anglais vers français)',
      grades: [
        'Structure de la présentation : 5/20',
        'Vocabulaire médical : 5/20',
        'Syntaxe et grammaire : 5/20',
        'Contenu, qualité de la présentation : 5/20',
      ],
    };
  }
  if (modality === 'Sur la plateforme - Dépôt de fichier') {
    return {
      name: `Dépôt de fichier (${text})`,
      summary: 'Dépôt de fichier sur la plateforme',
      grades: [
        'Méthodologie : 5/20',
        'Mots clé : 2.5/20',
        'Vocabulaire et termes médicaux : 10/20',
        'Syntaxe : 2.5/20',
      ],
    };
  }
  if (modality === 'Sur la plateforme - Test de placement') {
    return {
      name: `Passage du test de positionnement (${text})`,
      summary: 'Passage du test de positionnement afin de voir l\'évolution du niveau',
      grades: [],
    };
  }

  // Sur table
  if (modality === 'Sur table - Rédaction d\'un résumé') {
    return {
      name: `Examen sur table (${text})`,
      summary: 'Résumé d\'un texte en anglais',
      grades: [
        'Vocabulaire et termes médicaux : 10/20',
        'Structure : 3/20',
        'Contenu, qualité et idées globales : 5/20',
        'Syntaxe : 2/20',
      ],
    };
  }
  if (modality === 'Sur table - Traduction') {
    return {
      name: `Examen sur table (${text})`,
      summary: 'Traduction d\'un article médical (anglais vers français)',
      grades: [
        'Vocabulaire et termes médicaux : 10/20',
        'Compréhension globale : 5/20',
        'Syntaxe : 5/20',
      ],
    };
  }
  if (modality === 'Sur table - Dépôt de fichier') {
    return {
      name: `Examen sur table (${text})`,
      summary: 'Traduction d\'un article médical (anglais vers français)',
      grades: [
        'Méthodologie : 5/20',
        'Mots clé : 2.5/20',
        'Vocabulaire et termes médicaux : 10/20',
        'Syntaxe : 2.5/20',
      ],
    };
  }
};

export default examNameTranslation;
